module.exports = __webpack_public_path__ + "img/deal-supplier-active.fa2e6e67.png";